interface TenantSettings {
    currency: string;
    distanceUnits: string;
    GST: string;
    website: string;
    phoneNumber: string;
    employeesCount: string;
    logoFileName: string;
    country: string;
    businessLicenseId: string;
    shopOpeningTime: string;
    shopClosingTime: string;
    discountIncludesTax: string;
    laborTaxRate?: number;
    partsTaxRate?: number;
    salesTaxRate?: number;
    timezone?: string;

    isSalesTaxApplicableToLabor: boolean;
    isSalesTaxApplicableToParts: boolean;
    isSalesTaxApplicableToFees: boolean;

    isCustomerEmailRequired: boolean;
    isCustomerPhoneRequired: boolean;
    isCustomerAddressRequired: boolean;
    isCustomerBirthdateRequired: boolean;
    isCustomerSourceRequired: boolean;

    isMilesInRequiredForPosting: boolean;
    isMilesOutRequiredForPosting: boolean;
    isCustomerConnectedRequiredForPosting: boolean;
    isVehicleConnectedRequiredForPosting: boolean;

    // RO Aging Rules
    isLongRunningRoHighlightEnabled: boolean;
    longRunningRoHighlightThresholdDays: number;
    longRunningRoHighlightColor: string;
    longRunningRoHighlightStyle: LongRunningRoHighlightStyle;
}

export enum LongRunningRoHighlightStyle {
    BORDER_ONLY = 0,
    BACKGROUND_TINT = 1,
    BORDER_AND_BACKGROUND_TINT = 2,
}

export default TenantSettings;
